// TODO: Bu kısmı eğer localization içeriye alınırsa bunu da almamız gerekiyor.
export const calendarLocales = {
    tr: {
        lang: {
            locale: "tr_TR",
            placeholder: "Tarih Seçiniz",
            rangePlaceholder: ["Başlangıç Tarihi", "Bitiş Tarihi"],
            today: "Bugün",
            now: "Şimdi",
            backToToday: "Bugüne Dön",
            ok: "Tamam",
            clear: "Temizle",
            month: "Ay",
            year: "Yıl",
            timeSelect: "Zaman Seçiniz",
            dateSelect: "Tarih Seçiniz",
            monthSelect: "Ay Seçiniz",
            yearSelect: "Yıl Seçiniz",
            decadeSelect: "On Yıl Seçiniz",
            yearFormat: "YYYY",
            dateFormat: "DD/MM/YYYY",
            dayFormat: "D",
            dateTimeFormat: "DD/MM/YYYY HH:mm:ss",
            monthFormat: "MMMM",
            monthBeforeYear: true,
            previousMonth: "Önceki Ay (PageUp)",
            nextMonth: "Sonraki Ay (PageDown)",
            previousYear: "Önceki Yıl (Control + Sol)",
            nextYear: "Sonraki Yıl (Control + Sağ)",
            previousDecade: "Önceki On Yıl",
            nextDecade: "Sonraki On Yıl",
            previousCentury: "Önceki Yüzyıl",
            nextCentury: "Sonraki Yüzyıl",
            shortWeekDays: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
            shortMonths: [
                "Oca",
                "Şub",
                "Mar",
                "Nis",
                "May",
                "Haz",
                "Tem",
                "Ağu",
                "Eyl",
                "Eki",
                "Kas",
                "Ara"
            ]
        },
        timePickerLocale: {
            placeholder: "Zaman Seçiniz"
        },
        dateFormat: "YYYY-MM-DD",
        dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
        weekFormat: "YYYY-wo",
        monthFormat: "YYYY"
    },
    en: {
        lang: {
            locale: "en_US",
            placeholder: "Select date",
            rangePlaceholder: ["Start date", "End date"],
            today: "Today",
            now: "Now",
            backToToday: "Back to today",
            ok: "OK",
            clear: "Clear",
            month: "Month",
            year: "Year",
            timeSelect: "Select time",
            dateSelect: "Select date",
            monthSelect: "Choose a month",
            yearSelect: "Choose a year",
            decadeSelect: "Choose a decade",
            yearFormat: "YYYY",
            dateFormat: "M/D/YYYY",
            dayFormat: "D",
            dateTimeFormat: "M/D/YYYY HH:mm:ss",
            monthFormat: "MMMM",
            monthBeforeYear: true,
            previousMonth: "Previous month (PageUp)",
            nextMonth: "Next month (PageDown)",
            previousYear: "Last year (Control + left)",
            nextYear: "Next year (Control + right)",
            previousDecade: "Last decade",
            nextDecade: "Next decade",
            previousCentury: "Last century",
            nextCentury: "Next century",
            shortWeekDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            shortMonths: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ]
        },
        timePickerLocale: {
            placeholder: "Select time"
        },
        dateFormat: "YYYY-MM-DD",
        dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
        weekFormat: "YYYY-wo",
        monthFormat: "YYYY-MM"
    }
};
